import React, { useState } from 'react';
import OrangeButton from '../buttons/orange-button';
import OrangeButtonOutline from '../buttons/orange-button-outline';
import { useNavigate } from 'react-router-dom';

const PracticeTestSection = () => {
  const navigate = useNavigate();
  const [showSignupModal, setShowSignupModal] = useState(false);

  return (
    <div className="mx-auto mt-[48px] flex flex-col items-center gap-4 md:!mt-[80px] md:gap-12 lg:flex-row">
      <div className="w-full pr-4 lg:w-1/2 lg:p-0">
        <img src="/images/home/GeneratePracticeTest.png" alt="Practice Test" />
      </div>
      <div className="container w-full !max-w-[502px] space-y-4 !px-6 md:!pr-0 ">
        <div className="space-y-4">
          <h2 className="fredokaOne text-[32px]  font-normal leading-tight tracking-[-0.64px] text-[#012E33] md:text-[40px] md:tracking-[-0.8px]">
            Custom Practice Tests
          </h2>

          <p className="fredoka text-[18px] font-normal leading-[32px] tracking-[-0.18px] text-[#678285] md:text-[22px] md:tracking-[-0.22px]">
            Concierge-quality practice tests generated specifically for your student's coursework, 
            ensuring targeted review and improved performance.
          </p>
        </div>

        <div className="flex flex-col gap-4 pt-4 lg:flex-row">
          <OrangeButton
            className="fredokaOne !rounded-2xl"
            onClick={() => setShowSignupModal(true)}
            label={'Customize Practice Tests'}
          />
          <OrangeButtonOutline
            onClick={() => navigate('/products/academic-tutoring')}
            label={'Learn More'}
          />
        </div>
      </div>
    </div>
  );
};

export default PracticeTestSection;
